(function () {
  const SELECTOR = {
    share: '[data-fc-share]', shareTrigger: '[data-fc-share-trigger]', shareMenu: '[data-fc-share-menu]',
    copyLink: '[data-fc-copy-link]', copyLabel: '[data-fc-copy-label]', shareStatus: '[data-fc-share-status]',
    open: '[data-fc-restock-open]', modal: '[data-fc-restock-modal]', close: '[data-fc-restock-close]',
    form: '[data-fc-restock-form]', submit: '[data-fc-restock-submit]', status: '[data-fc-restock-status]'
  };
  let activeModal = null;
  let returnFocus = null;

  function closeShareMenus(except) {
    document.querySelectorAll(SELECTOR.share).forEach((share) => {
      if (share === except) return;
      const menu = share.querySelector(SELECTOR.shareMenu);
      if (menu) menu.hidden = true;
      share.querySelector(SELECTOR.shareTrigger)?.setAttribute('aria-expanded', 'false');
    });
  }
  function openFallbackShare(share) {
    const menu = share?.querySelector(SELECTOR.shareMenu);
    const trigger = share?.querySelector(SELECTOR.shareTrigger);
    if (!menu || !trigger) return;
    closeShareMenus(share);
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    menu.querySelector('a, button')?.focus();
  }
  async function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    const input = document.createElement('textarea');
    input.value = value; input.readOnly = true; input.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(input); input.select(); document.execCommand('copy'); input.remove();
  }
  function openModal(modal, opener) {
    if (!modal) return;
    activeModal = modal; returnFocus = opener || document.activeElement;
    modal.hidden = false; document.documentElement.classList.add('fc-modal-open');
    requestAnimationFrame(() => { modal.classList.add('is-open'); modal.querySelector('.fc-restock-modal__dialog')?.focus(); });
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open'); modal.hidden = true; document.documentElement.classList.remove('fc-modal-open');
    activeModal = null; if (returnFocus && document.contains(returnFocus)) returnFocus.focus(); returnFocus = null;
  }
  function trapFocus(event) {
    if (event.key !== 'Tab' || !activeModal) return;
    const nodes = [...activeModal.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])')]
      .filter((node) => node.offsetParent !== null);
    if (!nodes.length) return;
    if (event.shiftKey && document.activeElement === nodes[0]) { event.preventDefault(); nodes.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === nodes.at(-1)) { event.preventDefault(); nodes[0].focus(); }
  }
  function field(form, name) { return form.querySelector('[data-fc-field="' + name + '"]')?.value?.trim() || ''; }
  function submissionKey(form) {
    const input = form.querySelector('[data-fc-field="submissionKey"]');
    if (!input.value) input.value = crypto.randomUUID();
    return input.value;
  }
  function markUnavailableSections(root) {
    if (root.matches?.('[data-fc-restock-unavailable]')) {
      root.closest('main-product-section, .main_product_main')?.classList.add('fc-product-is-unavailable');
    }
    root.querySelectorAll('[data-fc-restock-unavailable]').forEach((marker) => {
      const section = marker.closest('main-product-section, .main_product_main');
      section?.classList.add('fc-product-is-unavailable');
    });
  }
  markUnavailableSections(document);
  new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node.nodeType === 1) markUnavailableSections(node);
  }))).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', async (event) => {
    const shareTrigger = event.target.closest(SELECTOR.shareTrigger);
    if (shareTrigger) {
      const share = shareTrigger.closest(SELECTOR.share);
      const title = share?.dataset.shareTitle || document.title;
      const url = share?.dataset.shareUrl || location.href;
      if (navigator.share) { try { await navigator.share({ title, text: title, url }); } catch (error) { if (error?.name !== 'AbortError') openFallbackShare(share); } }
      else openFallbackShare(share);
      return;
    }
    const copy = event.target.closest(SELECTOR.copyLink);
    if (copy) {
      const share = copy.closest(SELECTOR.share); const label = copy.querySelector(SELECTOR.copyLabel); const original = label?.textContent;
      const status = share?.querySelector(SELECTOR.shareStatus);
      try { await copyText(share?.dataset.shareUrl || location.href); const text = document.documentElement.lang === 'ar' ? 'تم نسخ الرابط' : 'Link copied'; if (label) label.textContent = text; if (status) status.textContent = text; setTimeout(() => { if (label) label.textContent = original; if (status) status.textContent = ''; }, 2400); }
      catch (_) { if (status) status.textContent = document.documentElement.lang === 'ar' ? 'تعذر نسخ الرابط' : 'Could not copy the link'; }
      return;
    }
    const opener = event.target.closest(SELECTOR.open);
    if (opener) { openModal(document.getElementById(opener.getAttribute('aria-controls')), opener); return; }
    const closer = event.target.closest(SELECTOR.close);
    if (closer) { closeModal(closer.closest(SELECTOR.modal)); return; }
    if (!event.target.closest(SELECTOR.share)) closeShareMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { if (activeModal) closeModal(activeModal); closeShareMenus(); }
    trapFocus(event);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(SELECTOR.form);
    if (!form) return;
    event.preventDefault(); if (!form.reportValidity()) return;
    const submit = form.querySelector(SELECTOR.submit); const status = form.querySelector(SELECTOR.status);
    submit.disabled = true; status.hidden = false; status.className = 'fc-restock-form__status is-saving'; status.textContent = status.dataset.saving;
    const payload = {
      submissionKey: submissionKey(form), productId: field(form, 'productId'), productTitle: field(form, 'productTitle'),
      productUrl: field(form, 'productUrl'), variantId: field(form, 'variantId'), variantTitle: field(form, 'variantTitle'),
      sku: field(form, 'sku'), customerEmail: field(form, 'customerEmail'), website: field(form, 'website')
    };
    try {
      const response = await fetch('/apps/fairness-operations/restock-subscriptions', {
        method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.id) throw new Error(result.error || 'Subscription failed');
      status.className = 'fc-restock-form__status is-success'; status.textContent = result.duplicate ? status.dataset.duplicate : status.dataset.success;
      form.querySelector('[data-fc-field="customerEmail"]').disabled = true;
    } catch (_) {
      status.className = 'fc-restock-form__status is-error'; status.textContent = status.dataset.error; submit.disabled = false;
    }
  }, true);
})();
